<template>
  <b-row>
    <b-col class="col-12 text-muted small text-uppercase mb-3 border-bottom">
      Da identificação
    </b-col>
    <b-form-group label="Código da oportunidade" class="col-12 col-md-6">
      <b-form-input v-model="form.codigo" trim></b-form-input>
    </b-form-group>
    <b-form-group label="Nome da oportunidade" class="col-12 col-md-6">
      <b-form-input v-model="form.q" trim></b-form-input>
    </b-form-group>
    <b-form-group label="Concedente" class="col-12 col-md-6">
      <b-form-input v-model="form.concedente" trim></b-form-input>
    </b-form-group>
    <b-form-group label="Categoria" class="col-12 col-md-6">
      <b-form-select
        v-model="form.categoria"
        text-field="nome"
        value-field="id"
        :options="categorias"
      ></b-form-select>
    </b-form-group>
    <b-col class="col-12 text-muted small text-uppercase mb-3 border-bottom">
      Prazos
    </b-col>
    <b-form-group
      label="Data de Criação (>=)"
      description="Período inicial de criação da oportunidade"
      class="col-6"
    >
      <date-input
        input-class="form-control"
        v-model="form.created_start"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label="Data de Criação (<=)"
      description="Período final de criação da oportunidade"
      class="col-6"
    >
      <date-input
        input-class="form-control"
        v-model="form.created_end"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Data de Atualização (>=)" class="col-6">
      <date-input
        input-class="form-control"
        v-model="form.update_start"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Data de Atualização (<=)" class="col-6">
      <date-input
        input-class="form-control"
        v-model="form.update_end"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Data de Disponibilização (>=)" class="col-6">
      <date-input
        input-class="form-control"
        v-model="form.available_start"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Data de Disponibilização (<=)" class="col-6">
      <date-input
        input-class="form-control"
        v-model="form.available_end"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Início das propostas (>=)" class="col-6">
      <date-input
        input-class="form-control"
        v-model="form.proposta_ini_start"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Início das propostas (<=)" class="col-6">
      <date-input
        input-class="form-control"
        v-model="form.proposta_ini_end"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Encerramento das propostas (>=)" class="col-6">
      <date-input
        input-class="form-control"
        v-model="form.proposta_fim_start"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Encerramento das propostas (<=)" class="col-6">
      <date-input
        input-class="form-control"
        v-model="form.proposta_fim_end"
        format="dd/MM/yyyy"
      />
      <b-form-invalid-feedback> Data inválida </b-form-invalid-feedback>
      <div>
        <b-form-checkbox
          v-model="form.proposta_indeterminada"
          class="cursor-pointer text-muted"
        >
          Prazo contínuo
        </b-form-checkbox>
      </div>
    </b-form-group>

    <b-row
      class="col-12 text-muted pb-2 small text-uppercase mb-3 border-bottom"
      no-gutters
    >
      Da classificação
    </b-row>

    <b-row class="col-12">
      <b-col>
        <b-form-group label="Natureza jurídica">
          <b-form-select
            v-model="form.natureza_juridica"
            :options="tiposInstituicoes"
            text-field="nome"
            value-field="id"
            multiple
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Qualificação da Proposta">
          <b-form-select
            v-model="form.qualificacao_proposta"
            :options="qualificacao_proposta"
          />
        </b-form-group>
        <b-form-group label="Áreas da oportunidade">
          <select-area v-model="form.areas" :multiple="true" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group label="ODS" class="col-12">
      <select-ods @change="form.ods = $event" />
    </b-form-group>
    <b-row
      class="col-12 text-muted pb-2 small text-uppercase mb-3 border-bottom"
      no-gutters
    >
      Dos valores
    </b-row>
    <b-form-group label="Moeda" class="col-12 col-md-4">
      <select-moeda v-model="form.moeda_id" />
    </b-form-group>
    <b-form-group label="Valores por projeto" class="col-12 col-md-4">
      <number-format v-model="form.valor_projeto_min" />
    </b-form-group>
    <b-form-group label="Valores Totais" class="col-12 col-md-4">
      <number-format v-model="form.valor_total_min" />
    </b-form-group>
    <b-row
      class="col-12 text-muted pb-2 small text-uppercase mb-3 border-bottom"
      no-gutters
    >
      Da localidade
      <b-form-checkbox v-model="form.internacional" class="ml-auto">
        Internacional
      </b-form-checkbox>
    </b-row>
    <b-form-group label="Estados" class="col-12">
      <select-multi-estado
        :disabled="form.internacional"
        v-model="form.estado"
      />
    </b-form-group>
    <b-form-group label="Municípios" class="col-12">
      <select-multi-municipio
        v-model="form.municipio"
        :disabled="form.internacional"
      />
    </b-form-group>
  </b-row>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import DateInput from "@/components/Form/DateInput.vue";
import NumberFormat from "@/components/Form/NumberFormat.vue";
import SelectMoeda from "@/modules/moedas/Components/SelectMoeda.vue";
import SelectMultiEstado from "@/modules/municipios/Components/SelectMultiEstado";
import SelectMultiMunicipio from "@/modules/municipios/Components/SelectMultiMunicipio";
import SelectOds from "@/components/Form/Ods.vue";
import SelectArea from "@/modules/areas/Components/SelectArea.vue";
import {
  convertQuery,
  convertFormToApi,
} from "@/helpers/functions/oportunidade_query";

export default {
  name: "BuscaAvancada",
  components: {
    DateInput,
    NumberFormat,
    SelectMoeda,
    SelectMultiEstado,
    SelectMultiMunicipio,
    SelectOds,
    SelectArea,
  },
  data: () => ({
    form: {
      codigo: "",
      nome: "",
      concedente: "",
      categoria: "",
      created_start: "",
      created_end: "",
      update_start: "",
      update_end: "",
      available_start: "",
      available_end: "",
      proposta_ini_start: "",
      proposta_ini_end: "",
      proposta_fim_start: "",
      proposta_fim_end: "",

      natureza_juridica: [],
      tipo_instrumento: "",
      qualificacao_proposta: "",
      valor_projeto_min: null,
      valor_total_min: null,
      moeda_id: null,
      estado: [],
      municipio: [],
      ods: [],
      areas: [],
      status: null,
    },
    tiposInstituicoes: [],
    tiposInstrumentos: [],
  }),
  computed: {
    ...mapState("categorias", ["categorias"]),
    ...mapGetters("oportunidades", ["qualificacao_proposta"]),
  },
  methods: {
    ...mapActions("municipios", ["ActionGetAllMunicipios"]),
    ...mapActions("categorias", { getAllCategorias: "ActionGetAll" }),
    ...mapActions("oportunidades", {
      getAllTiposInstrumentos: "ActionGetTiposInstrumentos",
    }),
    ...mapActions("tipos_instituicoes", { getTiposInstituicoes: "ActionFind" }),
    async setTiposInstituicoes() {
      const { data } = await this.getTiposInstituicoes();
      this.tiposInstituicoes = data;
    },
    async setTiposInstrumentos() {
      const tipos = await this.getAllTiposInstrumentos();
      this.tiposInstrumentos = [
        {
          value: null,
          text: "Selecione um tipo de instrumento",
        },
        ...tipos,
      ];
    },
    cleanForm(form = {}) {
      const cleanedForm = {};
      for (const key in form) {
        if (form[key]) {
          cleanedForm[key] = form[key];
        }
      }
      return cleanedForm;
    },
    getCleanedForm() {
      const source = convertFormToApi(this.form);
      return source;
    },
    onSave() {
      this.$emit("search", this.getCleanedForm());
    },
    clearForm() {
      this.form = Object.assign(this.form, {
        codigo: "",
        nome: "",
        concedente: "",
        categoria: "",
        created_start: "",
        created_end: "",
        update_start: "",
        update_end: "",
        available_start: "",
        available_end: "",
        date_start: "",
        date_end: "",
        natureza_juridica: [],
        tipo_instrumento: "",
        qualificacao_proposta: "",
        project_value: "",
        total_values: "",
        moeda: "",
        estado: [],
        ods: [],
        areas: [],
      });
    },
    async loadOptions() {
      await Promise.all([
        this.getAllCategorias(),
        this.setTiposInstituicoes(),
        this.setTiposInstrumentos(),
      ]);
    },
  },
  watch: {
    form: {
      deep: true,
      handler: function (value) {
        const response = this.getCleanedForm();
        this.$emit("input", response);
      },
    },
  },
  async created() {
    this.clearForm();
    await this.loadOptions();
    const dataForm = await convertQuery(this.$route.query);
    this.form = Object.assign(this.form, dataForm);
  },
};
</script>
